import http from "@/utils/request"
import mpHttp from "@/utils/mpRequest"

export const login = (data) => {
  return http.post("/login", data)
}

export const logout = (data) => {
  return http.post("/logout")
}

export const getUserInfo = (params) => {
  return http.get("/getUserInfo")
}

// 团购列表
export const purchase_list = (data) => {
  return http.post("/purchase/activity/list", data)
}

// 团购公司列表
export const purchase_company_list = (data) => {
  return http.post("purchase/company/list", data)
}

// 添加团购活动
export const openAccount = (data) => {
  return http.post("purchase/activity/openAccount", data)
}

export const changeStatus = (data) => {
  return http.post("purchase/activity/changeStatus", data)
}

export const editActivity = (data) => {
  return http.post("purchase/activity/editActivity", data)
}

export const editCompany = (data) => {
  return http.post("purchase/company/editCompany", data)
}

export const addCompany = (data) => {
  return http.post("purchase/company/addCompany", data)
}
//小程序开户
export const saas_client_mini = (data) => {
  return http.post("saasClient/openAccount", data)
}
//新接单开户
export const saas_client_new_jd = (data) => {
  return http.post("gs/open", data)
}
export const saas_client_new_mini = (data) => {
  return http.post("newSaasClient/openAccount", data)
}

export const add_DY = (params) => {
  return http.get("chatAgent/openAccount", {params})
}

export const querySmartAppCompany = (data) => {
  return http.post("saasClient/querySmartAppCompany", data)
}

export const editSmartAppCompany = (data) => {
  return http.post("saasClient/editSmartAppCompany", data)
}
//获取公司列表
export const dropDownCompany = () => {
  return http.get("purchase/company/dropDownCompany")
}

export const switchCompany = (data) => {
  return http.post("purchase/company/switchCompany",data)
}

// 公司 OSS 流量列表
export const get_oss_usage_companies = (params) => {
  return http.get("oss/usage/companies", { params })
}

// 当前公司 OSS 资源汇总
export const get_oss_usage_summary = (companyId) => {
  const config = {}
  if (companyId) {
    config.headers = { companyId }
  }
  return http.get("oss/usage/summary", config)
}

// 当前公司 OSS 日流量分页
export const get_oss_usage_daily_page = (params, companyId) => {
  const config = { params }
  if (companyId) {
    config.headers = { companyId }
  }
  return http.get("oss/usage/daily/page", config)
}

// OSS 文件批量删除（≤100 条，同步）
export const oss_files_batch_delete = (data) => {
  return http.post("oss/files/batch-delete", data)
}

// OSS 文件批量删除（>100 条，异步）
export const oss_files_batch_delete_async = (data) => {
  return http.post("oss/files/batch-delete-async", data)
}

// 相册迁移分类预览（走 VUE_APP_MPHOST）
export const get_album_migration_category_preview = (params, companyId) => {
  const config = { params }
  if (companyId) {
    config.headers = { companyId }
  }
  return mpHttp.get("album_migration/category_preview", config)
}

// 相册迁移-分类下相册预览
export const get_album_migration_album_preview = (params, companyId) => {
  const config = { params }
  if (companyId) {
    config.headers = { companyId }
  }
  return mpHttp.get("album_migration/album_preview", config)
}

// 相册迁移-创建批次
export const post_album_migration_batch_start = (data) => {
  return mpHttp.post("album_migration/batch/start", data)
}

// 相册迁移-批次进度
export const get_album_migration_batch = (batchId) => {
  return mpHttp.get(`album_migration/batch/${batchId}`)
}

// 相册迁移-标记未知（超时）；传 oldAlbumId 表示按相册明细
export const post_album_migration_batch_unknown = (batchId, oldCategoryId, message, oldAlbumId) => {
  const params = { message }
  if (oldAlbumId != null) {
    params.oldAlbumId = oldAlbumId
  } else {
    params.oldCategoryId = oldCategoryId
  }
  return mpHttp.post(`album_migration/batch/${batchId}/unknown`, null, { params })
}

// 相册迁移执行（走 VUE_APP_MPHOST，按分类/相册执行可能耗时较长）
export const post_album_migration_execute = (data) => {
  return mpHttp.post("album_migration/execute", data, { timeout: 600000 })
}
//获取角色列表
export const  staff_role_list= () => {
  return http.get("/staff/role")
}